import { App, Directive } from 'vue'

const globalDirective = (
  eventType: string,
  options?: AddEventListenerOptions
): Directive<HTMLElement, (e: Event) => void> => ({
  mounted: (_el, binding) => {
    window.addEventListener(eventType, binding.value, options)
  },
  unmounted: (_el, binding) => {
    window.removeEventListener(eventType, binding.value, options)
  }
})

// Registers the window-level directives shared by the full app and the embed.
export const registerGlobalDirectives = (app: App) => {
  app.directive('resize', globalDirective('resize'))
  app.directive(
    'globalClick',
    globalDirective('click') as Directive<HTMLElement, (e: MouseEvent) => void>
  )
  app.directive(
    'globalMousedown',
    globalDirective('mousedown') as Directive<
      HTMLElement,
      (e: MouseEvent) => void
    >
  )
  app.directive(
    'globalKeydown',
    globalDirective('keydown') as Directive<
      HTMLElement,
      (e: KeyboardEvent) => void
    >
  )
  app.directive(
    'globalKeyup',
    globalDirective('keyup') as Directive<
      HTMLElement,
      (e: KeyboardEvent) => void
    >
  )
  // passive: false so handlers can preventDefault (e.g. block page scroll while
  // dragging the mobile comment sheet)
  app.directive(
    'globalTouchmove',
    globalDirective('touchmove', { passive: false }) as Directive<
      HTMLElement,
      (e: TouchEvent) => void
    >
  )
  app.directive(
    'globalTouchend',
    globalDirective('touchend') as Directive<
      HTMLElement,
      (e: TouchEvent) => void
    >
  )
}
